import { Component, ElementRef, Input } from '@angular/core';
import { TotemWidget } from '../totem-widget';
import { AnalyticsService } from 'pg-lib/services/analytics.service';

@Component({
    selector: 'app-totem-widget-carousel',
    templateUrl: './totem-widget-carousel.component.html',
    styleUrls: ['./totem-widget-carousel.component.scss'],
    standalone: false
})
export class TotemWidgetCarouselComponent extends TotemWidget {
    
    @Input() size:'md'|'lg' = 'lg'
    @Input() imageList:Array<{ file: string, text: string, author: string }>;

    constructor(public elementRef:ElementRef, private analyticsService:AnalyticsService) {
        super(elementRef)
    }

    ngOnInit(): void {
        if(this.size == null) this.size = 'lg'

        if(this.fullScreenParams != null) {
            this.currentIndex = this.fullScreenParams;
        }
    }

    currentIndex = 0;

    hasInactiveFlip = true;

    onInactiveFlip() {
        if(this.imageList != null && this.imageList.length > 1) {
            this.currentIndex = (this.currentIndex + 1) % this.imageList.length;
        }
    }

    onLinkClick(link:string) {
        this.analyticsService.sendEvent('widgetOpenLink', {
            widget: this.id,
            link: link
        })
    }

    onCardActivate() {
        this.requestFullScreen.emit({ params: this.currentIndex });
    }
}
